import {
  API_HEADER_HOST,
  API_HEADER_X_FORWARDED_HOST,
} from '~~/modules/api/constants'
import { useHeaderStore } from '~~/modules/api/stores/header'

export default defineNuxtRouteMiddleware(() => {
  // skip middleware on client side entirely
  if (import.meta.client) return

  const header = useRequestHeaders([
    API_HEADER_HOST,
    API_HEADER_X_FORWARDED_HOST,
  ])

  const headerStore = useHeaderStore()
  headerStore.setHost(header[API_HEADER_HOST] as string)
  headerStore.setXForwardedHost(header[API_HEADER_X_FORWARDED_HOST] as string)

  return
})
